module.exports = __webpack_public_path__ + "img/链想力-LOGO.9e4ba13d.png";